const clearUserState = (state) => {
  state.user = null;
}

const setUser = (state, newUser) => {
  state.user = newUser;
}

const updateUser = (state, payload) => {
  state.user.first_name = payload.first_name
  state.user.last_name = payload.last_name
  state.user.email = payload.email
}

const updateUserShouldRequestBillingInfoFalse = (state) => {
  state.user.should_request_billing_info = false;
}

export default {
  clearUserState,
  setUser,
  updateUser,
  updateUserShouldRequestBillingInfoFalse,
}